"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelDialogBodySection = exports.border = void 0;
const tslib_1 = require("tslib");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const react_1 = tslib_1.__importDefault(require("react"));
exports.border = '1px solid #C9C9C9';
function LabelDialogBodySection({ width, grow, children, style, role }) {
    const flexGrow = grow ? 1000 : undefined;
    const minWidth = grow ? undefined : width;
    return (react_1.default.createElement(Section, { role: role, style: Object.assign(Object.assign({}, style), { flexGrow,
            width,
            minWidth }) }, children));
}
exports.LabelDialogBodySection = LabelDialogBodySection;
const Section = (0, vizportalclient_common_components_1.divWithStyle)('label-dialog-body-section', {
    overflowY: 'hidden',
    $nest: {
        '&:hover': {
            overflowY: 'auto',
            maxWidth: '100%',
            height: 'auto',
        },
    },
});
//# sourceMappingURL=LabelDialogStyle.js.map